module.exports = __webpack_public_path__ + "static/img/logo-v-gray.171487a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logos/logo-v-gray.png
// module id = 3Kkh
// module chunks = 1